import { config } from '../config.ts';
import { BetterLightsApi } from './api.ts';
import { ApiClient, type TokenProvider } from './client.ts';

let tokenProvider: TokenProvider = async () => null;

/** The app's API client; the account service installs the token provider at boot. */
export const api = new BetterLightsApi(new ApiClient(config.apiBaseUrl, (o) => tokenProvider(o)));

export function setTokenProvider(p: TokenProvider): void {
  tokenProvider = p;
}
